import { Link } from "react-router-dom";
import useGalleryData from "@/hooks/useGalleryData";

// Shared sticky header for the Blog pages — mirrors the catalogue top bar.
export default function BlogTopbar() {
  const { gallery } = useGalleryData();
  return (
    <nav className="grid-topbar" aria-label="Blog navigation">
      <Link to="/" className="grid-brand" data-testid="blog-brand">
        <span className="grid-brand__name">{gallery.artist_name}</span>
        {gallery.hero_tagline && <span className="grid-brand__tagline mono-caps">{gallery.hero_tagline}</span>}
      </Link>
      <div className="grid-topbar__links">
        <Link to="/" className="grid-topbar__link mono-caps" data-testid="blog-nav-hall">Gallery</Link>
        <Link to="/paintings" className="grid-topbar__link mono-caps" data-testid="blog-nav-paintings">Paintings</Link>
        <a
          className="grid-topbar__contact mono-caps"
          href={`mailto:${gallery.artist_email}?subject=${encodeURIComponent("Inquiry — " + gallery.exhibition)}`}
          data-testid="blog-contact"
        >
          Contact
        </a>
      </div>
    </nav>
  );
}
